"use strict";
angular.module('trsModalDialog', ["ngSanitize", "modalDialogHeightFixModule"]).
factory('modalDialog', ['$modal', "$compile", "$timeout", function($modal, $compile, $timeout) {
        return {
            //type :  success:成功   error:失败  info:提示   warning:警告 ask:询问  collection：收藏（五角星）
            alertType: function(title, content, type, isButtonShow, confirm, cancel, time, btn1, btn2) {
                var modalInstance = $modal.open({
                    templateUrl: "./utils/modalDialog/view/alertType_tpl.html",
                    windowClass: 'alertType',
                    backdrop: false,
                    controller: "alertTypeCtrl",
                    resolve: {
                        params: function() {
                            return {
                                title: title,
                                content: content,
                                type: type,
                                isButtonShow: isButtonShow,
                                time: time,
                                btn1: btn1,
                                btn2: btn2
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (angular.isFunction(confirm)) confirm();
                }, function() {
                    if (angular.isFunction(cancel)) cancel();
                });
            },
            //type :  success:成功   error:失败  info:提示   warning:警告 ask:询问  collection：收藏（五角星）
            success: function(content, type, isButtonShow, confirm, cancel, time, otherClass) {
                var windowClass = "success"; //默认样式，有偏移的样式
                if (otherClass != undefined) { //特殊情况，如针对body居中
                    windowClass = "success " + otherClass;
                }
                var modalInstance = $modal.open({
                    templateUrl: "./utils/modalDialog/view/success_tpl.html",
                    windowClass: windowClass,
                    backdrop: false,
                    controller: "successTipCtrl",
                    resolve: {
                        params: function() {
                            return {
                                content: content,
                                type: type,
                                isButtonShow: isButtonShow,
                                time: time,
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (angular.isFunction(confirm)) confirm();
                }, function() {
                    if (angular.isFunction(cancel)) cancel();
                });
            },
            //提示框模块
            confirmModal: function(title, content, confirm, cancel) {
                return $modal.open({
                    templateUrl: "./utils/modalDialog/view/confirmModal_tpl.html",
                    windowClass: 'confirmModal',
                    backdrop: false,
                    controller: "confirmModalCtrl",
                    resolve: {
                        title: function() {
                            return title;
                        },
                        content: function() {
                            return content;
                        },
                        callback: function() {
                            return confirm;
                        },
                        cancel: function() {
                            return cancel;
                        }
                    }
                });
            },
            //后台提示框模块
            backConfirmModal: function(title, content, confirm, cancel) {
                return $modal.open({
                    templateUrl: "./utils/modalDialog/view/backConfirmModal_tpl.html",
                    windowClass: 'backConfirmModal',
                    backdrop: false,
                    controller: "backConfirmModalCtrl",
                    resolve: {
                        title: function() {
                            return title;
                        },
                        content: function() {
                            return content;
                        },
                        callback: function() {
                            return confirm;
                        },
                        cancel: function() {
                            return cancel;
                        }
                    }
                });
            },
            //多条返回信息提示框
            multiReportsAlert: function(data, callback) {
                var modalInstance = $modal.open({
                    templateUrl: "./utils/modalDialog/view/multiReportsAlert_tpl.html",
                    windowClass: "multi-reports-alert-window",
                    controller: "multiReportsAlertCtrl",
                    // backdrop:true,
                    // animation:false,
                    resolve: {
                        data: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function() {
                    if (angular.isFunction(callback)) {
                        callback();
                    }
                });
            },
            /**
             * [miniMize description] 最小化
             * @return {[type]} [description]
             */
            miniMize: function($scope) {
                $scope.$element.addClass("modal-mini-mize");
                /**
                 * [maxiMizing description] 窗口最大化
                 * @return {[type]} [description]
                 */
                $scope.maxiMizing = function() {
                    $scope.$element.find(".mini-size").remove();
                    $scope.$element.removeClass('modal-mini-mize');
                    $scope.$element.css("left", 0);
                    reRender();
                };
                /**
                 * [reRender description] 重新计算排列
                 * @return {[type]} [description]
                 */
                function reRender() {
                    $timeout(function() {
                        var modals = $("body").find(".modal-mini-mize");
                        var left = 0;
                        modals.each(function(index) {
                            $(this).css("left", left + "px");
                            left = Number($(this).css("left").replace(/px/, "")) + $(this).width();
                        });
                    });
                }
                /**
                 * [close description] 关闭标签
                 * @return {[type]} [description]
                 */
                $scope.close = function() {
                    $scope.$close();
                    reRender();
                };
                var dom = ["<div class='mini-size'>",
                    "<span>" + $scope.$element.find(".publicModal .header p").html() + "</span>",
                    "<span ng-click='maxiMizing()'>口</span>",
                    "<span ng-click='close()'>X</span>",
                    "</div>"
                ].join("");
                dom = $compile($(dom))($scope);
                var left;
                var modals = $("body").find(".modal-mini-mize");
                if (modals.length === 1) {
                    left = 0;
                } else {
                    var lastModal = modals.eq(modals.length - 2);
                    left = lastModal.offset().left + lastModal.width();
                }
                $scope.$element.css({
                    left: left
                });
                $scope.$element.append(dom);
            }
        };
    }])
    .controller('multiReportsAlertCtrl', ['$scope', '$modalInstance', '$timeout', 'data', function($scope, $modalInstance, $timeout, data) {
        // if (data.ISSUCCESS == 'false' && data.TITLE == '签发照排') {
        //     $timeout(function() {
        //         $modalInstance.close();
        //     }, 6000);
        // }
        $scope.status = {
            "issuccess": data.ISSUCCESS,
            "title": data.TITLE
        };
        $scope.reports = {
            "success": [],
            "fail": []
        };

        if (data.ISSUCCESS == "false") {
            angular.forEach(data.REPORTS, function(value, key) {
                var a = value.DETAIL.indexOf("【");
                var b = value.DETAIL.indexOf("】");
                value.TITLE = value.DETAIL.slice(a + 1, b);
                if (value.ISSUCCESS == "true") {
                    $scope.reports.success.push(value);
                } else {
                    $scope.reports.fail.push(value);
                }
            });
        } else {
            angular.forEach(data.REPORTS, function(value, key) {
                var a = value.DETAIL.indexOf("【");
                var b = value.DETAIL.indexOf("】");
                value.TITLE = value.DETAIL.slice(a + 1, b);
                $scope.reports.success.push(value);
            });
        }

        $scope.cancel = function() {
            $modalInstance.close();
        };
    }]).controller("alertTypeCtrl", ["$scope", "$modalInstance", "params", function($scope, $modalInstance, params) {
        initStatus();

        function initStatus() {
            $scope.status = {
                type: params.type,
                title: params.title,
                content: params.content,
                isButtonShow: params.isButtonShow,
                time: !!params.time ? params.time : 2000,
                btn1: params.btn1 || "取消",
                btn2: params.btn2 || "确定"
            };
            if (!$scope.status.isButtonShow) {
                setTimeout(function() {
                    $modalInstance.close();
                }, $scope.status.time);
            }
        }
        $scope.confirm = function() {
            $modalInstance.close();
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]).controller('confirmModalCtrl', ['$scope', "$sce", 'title', 'content', 'callback', 'cancel', function($scope, $sce, title, content, callback, cancel) {
        $scope.cancel = function() {
            if (angular.isDefined(cancel)) cancel();
            $scope.$close();
        };
        $scope.isConfirm = function() {
            callback();
            $scope.$close();
        };
        $scope.title = title;
        $scope.content = $sce.trustAsHtml(content);
    }]).controller('backConfirmModalCtrl', ['$scope', "$sce", 'title', 'content', 'callback', 'cancel', function($scope, $sce, title, content, callback, cancel) {
        $scope.cancel = function() {
            if (angular.isDefined(cancel)) cancel();
            $scope.$close();
        };
        $scope.isConfirm = function() {
            callback();
            $scope.$close();
        };
        $scope.title = title;
        $scope.content = content;
    }]).controller("successTipCtrl", ["$scope", "$modalInstance", "params", function($scope, $modalInstance, params) {
        initStatus();

        function initStatus() {
            $scope.status = {
                type: params.type,
                title: params.title,
                content: params.content,
                isButtonShow: params.isButtonShow,
                time: !!params.time ? params.time : 2000,
            };
            if (!$scope.status.isButtonShow) {
                setTimeout(function() {
                    $modalInstance.close();
                }, $scope.status.time);
            }
        }
        $scope.confirm = function() {
            $modalInstance.close();
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);